import { usePathname } from 'next/navigation';

type PartnerPageResult = {
  isPartnerPage: boolean;
  partnerSlug: string | null;
};

const PARTNER_PATH_PREFIX = '/parceiros/';

export function useIsPartnerPage(): PartnerPageResult {
  const pathname: string | null = usePathname();

  if (!pathname?.startsWith(PARTNER_PATH_PREFIX)) {
    return { isPartnerPage: false, partnerSlug: null };
  }

  const pathAfterPartners = pathname.slice(PARTNER_PATH_PREFIX.length);
  const partnerSlug = pathAfterPartners.split('/')[0] || null;

  return {
    isPartnerPage: true,
    partnerSlug
  };
}
